import { render, staticRenderFns } from "./sankey.vue?vue&type=template&id=26a31a66&scoped=true&"
import script from "./sankey.vue?vue&type=script&lang=js&"
export * from "./sankey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a31a66",
  null
  
)

export default component.exports